module.exports = __webpack_public_path__ + "static/Fomorian-6ed89e6c84a7ad44dcdf6c042fceb01f.jpg";